<template>
  <se-popup classes="sm:w-[357px]" :show-close="false">
    <div class="flex flex-col justify-center items-center py-24 text-center">
      <div class="w-[56px] h-[56px] rounded-full bg-warning-10 text-warning-120 inline-flex justify-center items-center">
        <se-icon name="clock" :size="26"/>
      </div>
      
      <div class="my-24">
        <h1 class="text-h-m font-semibold mb-8">{{props.title}}</h1>
        <p class="text-b-s">{{props.description}}</p>
      </div>
      
      <se-button @click="closeChat(true)" type="tertiary" :loading="stopTimerLoading || unpausing" class="w-full">
        End Session
      </se-button>
    </div>
    
  </se-popup>
</template>

<script setup lang="ts">
import {storeToRefs} from "pinia";
import {chatStore} from "@/src/store/chat";
import SePopup from "@/src/shared/ui-kit/popup/Popup.vue";
import SeIcon from "@/src/shared/ui-kit/icon/Icon.vue";
import SeButton from "@/src/shared/ui-kit/button/Button.vue";

const props = defineProps<{
  title: string;
  description: string;
}>();

const chat = chatStore()
const {chatInfo, stopTimerLoading, unpausing} = storeToRefs(chat)
const {closeChat} = chat
</script>

<script lang="ts">
export default {
  name: 'SeWaitForClientPopup',
};
</script>